exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;color:#fff;background:transparent;margin-top:5vh;font-family:Exo\\ 2}.row{margin-right:0;margin-left:0}body{background:transparent;height:100vh}.loading,html{background:#89b7c0;background:-moz-linear-gradient(159deg,#89b7c0 0,#559db1 35%,#2a7186 100%);background:-webkit-linear-gradient(159deg,#89b7c0,#559db1 35%,#2a7186);background:linear-gradient(159deg,#89b7c0,#559db1 35%,#2a7186);background-attachment:fixed;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#89b7c0\",endColorstr=\"#2a7186\",GradientType=1)}h1,h2{font-weight:400}ul{list-style-type:none;padding:0}li{display:inline-block;margin:0 10px}a{color:#42b983}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6a6cd646","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 279
// module chunks = 0